import { render, staticRenderFns } from "./HistorischesIcon.vue?vue&type=template&id=33d95bb5"
import script from "./HistorischesIcon.vue?vue&type=script&lang=js"
export * from "./HistorischesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports